import { render, staticRenderFns } from "./instruction_modal.vue?vue&type=template&id=359cdb3f&scoped=true&"
import script from "./instruction_modal.vue?vue&type=script&lang=js&"
export * from "./instruction_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359cdb3f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('359cdb3f')) {
      api.createRecord('359cdb3f', component.options)
    } else {
      api.reload('359cdb3f', component.options)
    }
    module.hot.accept("./instruction_modal.vue?vue&type=template&id=359cdb3f&scoped=true&", function () {
      api.rerender('359cdb3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/instructions/modal/instruction_modal.vue"
export default component.exports